/**
 * Cart page entry — verbatim from v1 process_cart_page.js (research/05 §5.1,
 * §5.2; REQ-CART-1/2). ProcessCartPage exposes
 * `window.CPC_CartQuantityOnChange`, awaits LoadStoreConfig, then runs
 * CARTPAGE_adjustLineItems. Preserved quirks: qty-change handler STACKING per
 * invocation with the 1000 ms re-run (§8.13); the dead commented `cpc_`-strip
 * loop; the cache-busted /cart.js fetch; the Nova total conversion; the
 * faster-checkout branch dereferencing `cpc_fasterCheckoutConfig` unguarded
 * (null config → throw, §5.2.7). The legacy branch body lives in
 * ./rewriting.ts, the faster-checkout path in ./faster-checkout.ts, the
 * missing-variant selection + fetch in ./fetchvariants.ts (SPEC §2.1/§4.7).
 */
import { appState } from "../state/app-state";
import { IsNovaCurrencyCompatible, GetAmountAfterConversion } from "../currency";
import { LoadStoreConfig } from "../api/store-app";
import { CARTPAGE_LoadVariants, selectMissingVariants } from "./fetchvariants";
import { UpdateCartElement, setCartDataFromShopify } from "./faster-checkout";
import { LegacyCartRewrites } from "./rewriting";
import $ from "jquery";

export async function ProcessCartPage(): Promise<void> {
  window.CPC_CartQuantityOnChange = CARTPAGE_adjustLineItems;
  await LoadStoreConfig();
  CARTPAGE_adjustLineItems();
}

export function CARTPAGE_adjustLineItems(): void {
  $('input[class*="qty"]').on("change", function () {
    setTimeout(() => {
      console.log("quantity changed");
      CARTPAGE_adjustLineItems();
    }, 1000);
  });

  //Remove the cart unique_id
  var all = document.querySelectorAll("li,p,span,label");
  var regexPattern = /[a-zA-Z0-9: ]?cpc_[a-zA-Z0-9]+/gi;
  for (var i = 0, max = all.length; i < max; i++) {
    //let elem = all[i];
    //if (regexPattern.test(elem.textContent)) {
    //    $(elem).html('');
    //}
  }

  fetch("/cart.js?cache=false&q=" + Math.random())
    .then((response) => response.json())
    .then(async function (cartData) {
      setCartDataFromShopify(cartData);
      let cart_items = cartData.items;
      let cart_total_price = cartData.total_price;
      let isNovaCurrencyCompatible = IsNovaCurrencyCompatible();

      if (isNovaCurrencyCompatible) {
        let user_curr = cartData.currency;
        const result = GetAmountAfterConversion(parseFloat(cart_total_price), user_curr, null);
        cart_total_price = result;
      }

      let cart_original_total_price = cartData.original_total_price;
      let allVariantsFromCart: any[] = [];
      for (let i = 0; i < cart_items.length; i++) {
        allVariantsFromCart.push({ index: i, item: cart_items[i] });
      }

      var missingVariants = selectMissingVariants(allVariantsFromCart);

      var cpc_variantData = await CARTPAGE_LoadVariants(missingVariants);
      if (appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig !== null && appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.enabled === true) {
        console.log("Faster checkout behavior: New");
        //Use new faster checkout behavior
        UpdateCartElement(allVariantsFromCart, cpc_variantData);
      }
      else {
        LegacyCartRewrites(cartData, allVariantsFromCart, cpc_variantData, cart_total_price, isNovaCurrencyCompatible);
      }
    });
}
